module.exports = __webpack_public_path__ + "img/img-2-mobile.812f7d97.webp";